import { reactive } from 'vue'

export const botCreationLimitDialog = reactive({ open: false, unavailable: false, count: null, limit: null, message: '' })

export function showBotCreationLimitDialog(details = {}, unavailable = false, message = '') {
    Object.assign(botCreationLimitDialog, { open: true, unavailable, count: details.count ?? null, limit: details.limit ?? null, message })
}

export function showBotLimitError(error) {
    if (error?.code === 'BOT_CREATION_UNCERTAIN') { showBotCreationLimitDialog({}, true, 'A previous bot creation could not be confirmed. Contact your administrator.'); return true }
    if (error?.code !== 'BOT_LIMIT_REACHED') return false
    showBotCreationLimitDialog(error.details || {})
    return true
}
